/**
 * Fix: Override the problematic methods to properly handle mobile scroll lock bug
 */
(function() {
  'use strict';
  const patchFilters = () => {
    const CollectionFilters = customElements.get('collection-filters');
    
    if (!CollectionFilters) {
      setTimeout(patchFilters, 100);
      return;
    }
    const originalRenderSectionFromFetch = CollectionFilters.prototype.renderSectionFromFetch;
    const originalRenderSectionFromCache = CollectionFilters.prototype.renderSectionFromCache;
    const originalRenderTagFiltersProducts = CollectionFilters.prototype.renderTagFiltersProducts;
    const originalFinishLoading = CollectionFilters.prototype.finishLoading;

    // Patch renderSectionFromFetch
    CollectionFilters.prototype.renderSectionFromFetch = function(t) {
      fetch(t).then((t) => t.text()).then((e) => {
        const i = e;
        this.filterData = [...this.filterData, { html: i, url: t }];
        this.inputSort = this.container.querySelectorAll("[data-input-sort]");
        this.renderFilters(i);
        this.bindFilterButtonsEvents();
        this.hideFiltersOnMobile();
        this.renderProductGrid(i);
        this.updateProductsCount(i);
        this.finishLoading();
      //this.mobileFiltersScrollLock()
      });
    };

    // Patch renderSectionFromCache
    CollectionFilters.prototype.renderSectionFromCache = function(t, e) {
      const i = this.filterData.find(t).html;
      this.renderFilters(i, e);
      this.hideFiltersOnMobile();
      this.renderProductGrid(i);
      this.updateProductsCount(i);
      this.finishLoading();
    //this.mobileFiltersScrollLock()
    };

    // Patch renderTagFiltersProducts
    CollectionFilters.prototype.renderTagFiltersProducts = function(t) {
      this.startLoading();
      fetch(t).then((t) => t.text()).then((e) => {
        const i = e;
        const s = (new DOMParser).parseFromString(i, "text/html");
        const r = s.querySelector("[data-collection-products]");
        const o = r.innerHTML;
        const n = s.querySelector("[data-collection-filters]").innerHTML;
        this.productGrid.innerHTML = o;
        this.filters.innerHTML = n;
        this.inputSort = this.container.querySelectorAll("[data-input-sort]");
        this.filtersForm = document.querySelector("[data-collection-filters-form]");
        this.filterData = [...this.filterData, { html: i, url: t }];
        this.alreadyClicked = false;
        this.bindFilterTagButtonsEvents();
        this.bindFilterButtonsEvents();
        this.bindSortChangeEvent();
        this.bindToggleButtonsEvents();
        this.reInitAjaxinate(r);
        this.initProductGridEvents();
        this.updateProductsCount(i);
        this.finishLoading(); // ADDED: was missing in original
      //this.mobileFiltersScrollLock() - this was causing the scroll lock bug
        this.hideFiltersOnMobile();
        this.filterShowMore();
        history.replaceState && window.history.pushState({ path: t }, "", t);
      }).catch((t) => {
        this.finishLoading();
        console.log(`Error: ${t}`);
      });
    };

    // Patch finishLoading
    CollectionFilters.prototype.finishLoading = function() {
      const t = document.querySelectorAll('[data-section-type="popups"] .popup--visible');
      const e = t.length > 0;
      
      this.container.classList.remove("is-loading");
      
      if (e) {
        let e = 0;
        [...t].forEach((t) => {
          t.hasAttribute("data-prevent-scroll-lock") && (e += 1);
        });
        if (e === t.length) {
          document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true, detail: 300 }));
        }
      } else {
        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true, detail: 300 }));
      }
    };
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchFilters);
  } else {
    patchFilters();
  }
})();
